import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {PathName} from "@/constant/routeData";
// 总主页
import index from "@/pages";
// // 登陆页
import login from "@/pages/login";
// // 总主页 -> 修改密码
// // 总主页 -> 测试中心
import homeRouter from "@/router/homeRouter";

// 周报
import ReportRouter from "@/router/reportRouter";

// 假期
import AttendanceRouter from "@/router/attendanceRouter";

// 需求
import RequirementRouter from "@/router/requirementRouter";

// 项目
import ProjectRouter from "@/router/projectRouter";

import TaskRouter from "@/router/taskRouter";

// 403
import Permission from '@/pages/403/403.vue'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(Router)
//
//
let curRoutes = [
  // 登录
  {
    path: '/login',
    name: PathName.Login,
    component: login,
  },
  // 403
  {
    path: '/403',
    name: 'Permission',
    component: Permission
  },
  // 总主页
  {
    path: '/',
    name: PathName.Home,
    component: index,
    redirect: PathName.Dashboard,
    children: [
      ...homeRouter,
      // report
      ...ReportRouter,
      ...AttendanceRouter,
      ...RequirementRouter,
      ...ProjectRouter,
      ...TaskRouter,
    ]
  }
]
//
Vue.use(Router)
let router = new Router({
  mode: 'hash',
  // 所有的路由配置
  routes: curRoutes
})
router.beforeEach(
  store.commit('FLASH_TOKEN'),
  // store.commit('ENDURING_PROJECT_INFOS') //项目信息
)
//
export default router
